module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./inviationView.js"));
	}, "InviationView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=InviationView!./src/pages/Promote/OfflineActivity/Invitation/inviationView.js
// module id = 2119
// module chunks = 367